import * as yup from 'yup'

const schema = yup.object().shape({
  content: yup.string().richTextRequired(),
  attachments: yup.mixed().fileUpload({ sizeLimit: 25 }),
})

export default schema
